import { render, staticRenderFns } from "./FacilitiesFeatures.vue?vue&type=template&id=62d6707d"
import script from "./FacilitiesFeatures.vue?vue&type=script&lang=js"
export * from "./FacilitiesFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports